/**
 * Whether the replay's keyboard shortcuts (arrows, Home, End) should be
 * suppressed because something modal is open over the page (GRA-147). Kept
 * as its own one-function module, deliberately not folded into LoopShell's
 * keydown handler, so GRA-146's own "a dialog is open" flag can drop in here
 * later without touching the replay code around it.
 *
 * Checks the DOM rather than tracking a flag through props/state: every
 * dialog in this app (InfoDialog, and any future one) already renders
 * `role="dialog"`, and a native `<dialog open>` is covered too in case one is
 * ever used instead, so this needs no wiring into whatever opens a dialog.
 */
export function isReplayKeyBlocked(): boolean {
  if (typeof document === "undefined") return false;
  return document.querySelector('dialog[open], [role="dialog"]') !== null;
}
